import { Component, OnInit, Input, Output, EventEmitter, inject, ViewChild, TemplateRef } from '@angular/core';
import { CommonModule, formatDate  } from '@angular/common';
import { InicioService } from '../../../services/inicio.service';
import { appsettings } from '../../../settings/appsettings';
import { ModalComponent } from "../../modal/modal.component";
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ListaPerfilComponent } from "../lista-perfil/lista-perfil.component";

@Component({
  selector: 'app-lista-ocupacion',
  standalone: true,
  imports: [ModalComponent, CommonModule, ListaPerfilComponent],
  templateUrl: './lista-ocupacion.component.html',
  styleUrl: './lista-ocupacion.component.css'
})
export class ListaOcupacionComponent implements OnInit {
  @ViewChild(ModalComponent) mdl!: ModalComponent;
  @Output() vuelve = new EventEmitter<any>();
  @Input() motor?: any;

  private srvLogin = inject(InicioService);
  private modalService = inject(NgbModal);
  private contentCargando: NgbModalRef | undefined;
  url = appsettings.apiUrl;

  titulo!: string;
  tipo_color!: string;
  letra_color!: string;
  mensaje!: string;
  errorMessage: string = '';

  isPerfil: boolean = false;

  ocupacinesListi: any = [];
  perfilesList: any = [];
  nombre_ocupacion: string = '';
  perfil: any = [];
  color_env: string = '';
  icono: any;
  id_motor: any;

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    //console.table(this.motor);
    this.mdl.cargando();
    this.srvLogin.listarOcupaciones(this.motor.id_motor_productivo).subscribe({
      next: (rs) => {
        this.mdl.cerrar();
        this.ocupacinesListi = rs.data;
        //console.table(rs.data);
      },
      error: (error) => {
        this.errorMessage = error.message;
      },
    });
  }

  informacion(content: TemplateRef<any>, datos: any) {
    //console.table(datos)
    this.perfilesList = datos.formaciones;
    this.nombre_ocupacion = datos.ocupacion;
		//this.contentCargando = this.modalService.open(content, { fullscreen: true });
    this.contentCargando = this.modalService.open(content, { size: 'xl' });

	}

  muestraPerfil(datos: any, color: any, icono: any, id_motor: any){
    this.isPerfil = true;
    this.perfil = datos;
    this.color_env = color;
    this.icono = icono;
    this.id_motor = id_motor;
    if(this.contentCargando){
      this.contentCargando.close();
      this.contentCargando  = undefined;
    }
  }

  volver(){
    this.vuelve.emit({value: false, validador: false});
  }

  volver_2(rsl: any) {
    this.isPerfil = rsl.value;
  }
}
